import React from 'react'
import axios from 'axios';

import { Button, message } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Redirect } from 'react-router-dom';
import { API_ENDPOINT } from 'config'


import LoginForm from './LoginForm'
import FooterContent from 'components/LayoutComponents/FooterContent'
import { setUserState } from 'reducers'
import './style.scss'

const mapStateToProps = (state, props) => ({
  userState: state.get('app').get('userState').toJS(),
})

@connect(mapStateToProps)
@withRouter
class Login extends React.Component {
  state = {
    backgroundImage: 'url(resources/images/login/1.jpg)',
    redirect: false
  }

  generateBackground = () => {
    let { backgroundImage } = this.state

    let min = 1
    let max = 5
    let picNumber = Math.floor(Math.random() * (max - min + 1)) + min
    backgroundImage = 'url(resources/images/login/' + picNumber + '.jpg)'
    this.setState({
      backgroundImage: backgroundImage,
    })
  }


  handleLogin(form_data) {

    const { dispatch } = this.props

    console.log(process.env.NODE_ENV)

    axios.post(`${API_ENDPOINT}/auth/local`, form_data)
      .then(res => {
        message.success('Logged in.')
        dispatch(setUserState(res.data))
        this.setState({ redirect: '/'})

      })
      .catch(error => {
          message.error('Incorrect password or username.')
      })

  }

  componentDidMount() {
    console.log(this.props.userState)
  }


  render() {
    const { backgroundImage, fullSize } = this.state
    const { redirect } = this.state

    if (redirect) {
      return <Redirect to={redirect} />
    }

    return (

      <div
        className='login login--fullscreen'
        style={{ backgroundImage: backgroundImage }}
      >
        <div className="login__header">
          <div className="row">
            <div className="col-lg-8">
              <div className="login__header__logo">
                <a href="/">
                  <img
                    src="resources/images/logo-login.png"
                    alt="adbility media"
                  />
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="login__header__menu">
                <ul className="list-unstyled list-inline">
                  <li className="list-inline-item active">
                    <a href="/">Login</a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://adbility-media.com/">Home</a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.adbility-media.com/kontakt/">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="login__block">
          <div className="row">
            <div className="col-xl-12">
              <div className="login__block__promo text-white text-center">
                <h1 className="mb-3 text-white">
                  <strong>PUBLISHER DASHBOARD</strong>
                </h1>
                <p>
                </p>
              </div>
              <div className="login__block__inner">
                <div className="login__block__form">
                  <h4 className="text-uppercase">
                    <strong>Welcome!</strong>
                  </h4>
                  <br />
                  <LoginForm callback={this.handleLogin.bind(this)} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="login__footer text-center">
          <FooterContent />
        </div>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/containers/LoginPage/Login/index.js